export type OptionItem = {
  id: number;
  name: string;
};

export const brand: OptionItem[] = [
  { id: 1, name: "Puma" },
  { id: 2, name: "Nike" },
  { id: 3, name: "Adidas" },
  { id: 4, name: "Reebok" },
  { id: 5, name: "Under Armour" },
  { id: 6, name: "New Balance" },
  { id: 7, name: "Asics" },
  { id: 8, name: "Converse" },
  { id: 9, name: "Vans" },
  { id: 10, name: "Fila" },
  { id: 11, name: "Skechers" },
  { id: 12, name: "Lululemon" },
  { id: 13, name: "Columbia" },
  { id: 14, name: "The North Face" },
  { id: 15, name: "Patagonia" },
];
